import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import 'rxjs/add/operator/do';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {SettingENUM} from '../enums/setting.enum';
import {Principal} from '../services/principal';
import {Utils} from '../services/Utils';
import {MatDialog} from '@angular/material';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private _router: Router,
              private _dialog: MatDialog,
              private _utils: Utils,
              private _principal: Principal,
              private _translateService: TranslateService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // location.origin
    const headers = {
      'Accept': 'application/json',
      'Accept-Language': `${this._translateService.currentLang}`,
      'clientId': `${localStorage.getItem('clientId')}`
    };
    const noToken = request.headers.get('noToken');
    if (noToken !== 'true') {
      const token = localStorage.getItem(`${SettingENUM.TOKEN_STR}`);
      if (token && token.length > 10) {
        headers['Authorization'] = `Bearer ${token}`;
      }

    }
    let contentType = request.headers.get('Content-Type');
    if (!contentType) {
      contentType = 'application/json';
    }
    const noContentType = request.headers.get('noContentType');
    if (noContentType !== 'true') {
      headers['Content-Type'] = contentType;
    }
    const clone = request.clone({setHeaders: headers});
    return next.handle(clone).do(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this._dialog.closeAll();
            this._principal.deleteTokenAndUser();
            if (this._router.url.indexOf('login') == -1) { // this._router.url.length > 2
              const login = 'login';
              this._router.navigate([login], {queryParams: {returnUrl: this._router.url}});
            } else {
              console.log('already return', this._router.url);
            }
          } else if (err.status === 403) {
            console.log('access denied', err);
          }
          this._utils.blockStop();
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/config/auth.interceptor.ts